import React, { useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { useParams } from "react-router-dom";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { useEffect } from "react";
import ScholarDetailsProfileView from "./ScholarDetailsProfileView";
import {
  dummyGamesForScholarProfileDetails,
  dummyNftsForScholarProfileDetails,
} from "../../data/dummyScholars";

const ScholarDetailsProfile = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downLg = useMediaQuery(theme.breakpoints.down("lg"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));

  const { scholars } = useTypedSelector((state) => state.apiReducer);

  const { scholarId } = useParams();

  const [scholar, setScholar] = useState(
    scholars.find((sc) => sc._id === scholarId && sc.guildId)
  );

  useEffect(() => {
    setScholar(scholars.find((sc) => sc._id === scholarId && sc.guildId));
  }, [scholars, scholarId]);

  const NftBoxProps = () => {
    if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(30, 1fr)",
        gap: "30px",
      };
    } else if (downLg) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(35, 1fr)",
        gap: "30px",
      };
    } else if (downXl) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(45, 1fr)",
        gap: "30px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(50, 1fr)",
        gap: "30px",
      };
    }
  };

  return (
    <ScholarDetailsProfileView
      theme={theme}
      colors={colors}
      scholars={scholars}
      scholarId={scholarId}
      scholar={scholar}
      nfts={dummyNftsForScholarProfileDetails}
      games={dummyGamesForScholarProfileDetails}
      NftBoxProps={NftBoxProps}
    />
  );
};

export default ScholarDetailsProfile;
